import React, { useEffect, useState } from "react";
import WidgetAjax from '../../../widget/WidgetAjax';
import Config from '../../../config/Config';
import DetailInfo from "../../com/Detail_info";
import JobTableScroll from "../../com/job/scrollCardTable";
import HeaderSearch from "./HeaderSearch";

const path = Config.getBasePath();
let filePath = Config.getFilePath();

const AdvertJob = ({
    info,
    history,
    headerOperation,
    scrollTop = 0, // 滚动距离
    footerOffsetTop = 0, // 底部距离可视区域顶部距离
    clientHeight = 0, // 可视区域高度
}) => {
    const [activeJobId, setActiveJobId] = useState(null);
    const [activeJobInfo, setActiveJobInfo] = useState({});
    const [infoLoading, setInfoLoading] = useState(false);
    const [jobTypeOptions, setJobTypeOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [eduOptions, setEduOptions] = useState([]);
    const [salaryOptions, setSalaryOptions] = useState([]);
    const [expOptions, setExpOptions] = useState([]);
    const [ageOptions, setAgeOptions] = useState([]);
    const [jobParams, setJobParams] = useState({ JOBSTATE: ['2'] });
    const [hasMore, setHasMore] = useState(true);
    const options = {};
    const conditionList = [
        { label: '职位类型', props: 'JOBTYPE', options: jobTypeOptions, valueProps: "code" },
    ];
    const filterList = [
        { options: eduOptions, props: 'REQEDU', label: '学历要求', mode: 'multiple' },
        { options: salaryOptions, props: 'SAL', label: '薪资待遇', mode: 'single' },
        { options: expOptions, props: 'REQWE', label: '经验要求', mode: 'single' },
        { options: ageOptions, props: 'REQAGE', label: '年龄要求', mode: 'single' },
    ];
    // 获取岗位信息
    const getJobInfo = (id) => {
      
        WidgetAjax.ajax({
            url: path + '/job/info',
            params: {
                id: id
            },
            callback: (res) => {
                if (res.status == 0) {
                    setActiveJobInfo(res.result);
                    setInfoLoading(false);
                }
            }
        })
    }

    const reloadInfoData = () => {
        getJobInfo(activeJobId)
    }
    // 选择岗位回调
    const onCheck = (value) => {
        setActiveJobId(value);
    }
    // 获取岗位列表回调
    const onGetJobListCallback = () => {
        setInfoLoading(false);
    }
    // 获取职位类型
    const getJobTypeData = () => {
        const onGetJobData = (res) => {
            if (res.status == 0) {
                setJobTypeOptions(res.results || []);
            }
        }
        WidgetAjax.ajax({ url: path + '/recruitment/job_type', params: { parent_code: "0", }, callback: onGetJobData })
    }
    // 是否还有加载更多回调函数
    const onHasMoreCallback = (value) => {
        setHasMore(value);
    }
    // 获取维度数据
    const loadDimension = (code) => {
        const onDimension = (res, code) => {
            if (res.status == 0 && res.results && res.results.length > 0) {
                let arr = res.results[0].values.map((item) => {
                    return { label: item.name, value: item.value }
                })
                if (code === 'D551') setAgeOptions(arr); //年龄要求
                else if (code === 'D500') setEduOptions(arr); //学历要求
                else if (code === 'D423') setExpOptions(arr); //经验要求  
                else if (code === 'D503') setSalaryOptions(arr); //薪资要求
            }
        }
        WidgetAjax.ajax({ url: path + "/widget/dimension", params: { "dimension": code }, callback: (res) => onDimension(res, code) });
    }


    // 岗位检索
    const onSearch = (value) => {
        setJobParams({
            ...value,
        });
    }

    useEffect(() => {
      
        // （比如列表筛选后没有数据、onCheck(undefined)）loading 被打开却没人关闭
        getJobTypeData();
        loadDimension('D551');
        loadDimension('D500');
        loadDimension('D423');
        loadDimension('D503');
        if (activeJobId) {
            setInfoLoading(true);
            getJobInfo(activeJobId);
        } else {
            // 联动机理:左侧列表为空 → activeJobId 变 undefined → 清空 activeJobInfo → DetailInfo 渲染 NoData
            setActiveJobInfo({});
            setInfoLoading(false);   // 兜底:防止未来其他流程残留 loading=true
        }
    }, [activeJobId])
    return <>
        <div className="enterprise-detail-jobSearch">
            <HeaderSearch
                options={options}
                conditionList={conditionList}
                onSearch={(value) => onSearch(value)}
                loading={loading}
                isShowSearch={false}
                filterList={filterList}
                scrollTop={scrollTop}
            />
        </div>
        <div className="enterprise--detail-content-job-wrap">
            <div className="enterprise--detail-job-list">
                {
                    info && info.id ?
                        <JobTableScroll
                            info={info}
                            isEnterprise={true}
                            onCheck={onCheck}
                            onGetJobListCallback={onGetJobListCallback}
                            params={jobParams}
                            onHasMoreCallback={onHasMoreCallback}
                        /> : null
                }

            </div>
            <div className={`enterprise--detail-job-info ${scrollTop > 330 ? (((footerOffsetTop < clientHeight) && !hasMore) ? "enterprise_job_detail_absolute" : "enterprise_job_detail_fixed") : ""}`}>
                <DetailInfo
                    info={activeJobInfo}
                    infoLoading={infoLoading}
                    history={history}
                    headerOperation={headerOperation}
                    contentList={[
                        "socialBenefits",  // 福利待遇
                        "baseInfo",  // 基本概况
                        "jobDetail", // 岗位详情
                        "AIsuggest", // AI投递建议
                        "progress", // 入职流程
                        "environment", // 岗位环境
                        "address", // 工作地址
                    ]}
                    reloadInfo={reloadInfoData}
                />
            </div>
        </div>
    </>
}

export default AdvertJob;